import React from 'react';
import PropTypes from 'prop-types';
import Preloader from '../Preloader';
import Dates from './Dates';
import EventsList from './EventsLists';
import * as C from '../../models/calendar/constants';


const daysList = [
    { day: 8, name: 'Чт', long: 'Четверг' },
    { day: 9, name: 'Пт', long: 'Пятница' },
    { day: 10, name: 'Сб', long: 'Суббота' },
    { day: 11, name: 'Вс', long: 'Воскресенье' },
    { day: 12, name: 'Пн', long: 'Понедельник' },
    { day: 13, name: 'Вт', long: 'Вторник' },
    { day: 14, name: 'Ср', long: 'Среда' },
    { day: 15, name: 'Чт', long: 'Четверг' },
    { day: 16, name: 'Пн', long: 'Пятница' },
    { day: 17, name: 'Сб', long: 'Суббота' },
    { day: 18, name: 'Вс', long: 'Воскресенье' },
    { day: 19, name: 'Пн', long: 'Понедельник' },
    { day: 20, name: 'Вт', long: 'Вторник' },
    { day: 21, name: 'Ср', long: 'Среда' },
    { day: 22, name: 'Чт', long: 'Четверг' },
    { day: 23, name: 'Пт', long: 'Пятница' },
    { day: 24, name: 'Сб', long: 'Суббота' },
    { day: 25, name: 'Вс', long: 'Воскресенье' }
];


function getCardLive(tags, id) {
    let find = false;
    if (tags) {
        tags.forEach((item) => {
            if (item._id === `OI-${id}`) {
                find = true;
            }
        });
    }
    return find;
}

class Calendar extends React.Component {
    static propTypes = {
        // eslint-disable-next-line
        answer: PropTypes.any,
        // eslint-disable-next-line
        actions: PropTypes.any,
        limits: PropTypes.number
    };

    static defaultProps = {
        limits: 8
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedDay: 25,
            isLoading: true,
            events: [],
            lives: []
        };
        this.buffEvents = [];
        this.updateSelectedDate = this.updateSelectedDate.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.prevSlide = this.prevSlide.bind(this);
    }

    componentDidMount() {
        this.props.actions.loadCalendar();
    }

    componentWillReceiveProps(p) {
        if (p.answer && p.answer.state) {
            if (p.answer.state === C.FINISH_LOAD_CALENDAR) {
                this.setState({
                    events: p.answer.data.data
                });

                const ids = p.answer.data.data.map(item => item._id);
                this.props.actions.loadCalendarOrder(ids);
            }

            if (p.answer.state === C.FINISH_LOAD_LIVES) {
                const resultItems = [];
                this.state.events.forEach((item) => {
                    const newItem = { ...item };
                    p.answer.data.forEach((doc) => {
                        if (getCardLive(doc.privateTags, item._id)) {
                            newItem.liveUpdate = doc.href;
                        }
                    });
                    resultItems.push(newItem);
                });

                this.setState({
                    events: resultItems,
                    isLoading: false
                });
            }

            if (p.answer.state === C.FINISH_LOAD_CHAMPIONATS) {
                const resultEvents = this.state.events.map(item => (
                    {
                        ...item,
                        ...{ ch: (p.answer.data[item._id] ? p.answer.data[item._id].data : {}) }
                    }
                ));

                this.buffEvents = resultEvents;

                this.setState({
                    events: resultEvents
                });
                this.props.actions.loadCalendarLives();
            }
        }
    }


    updateSelectedDate(day) {
        this.setState({
            selectedDay: day
        });
    }

    nextSlide() {
        const day = this.state.selectedDay + 1;
        let find = false;
        daysList.forEach((item) => {
            if (item.day === day) {
                find = true;
            }
        });

        if (find) {
            this.setState({
                selectedDay: day
            });
        } else {
            this.setState({
                selectedDay: daysList[0].day
            });
        }
    }

    prevSlide() {
        const day = this.state.selectedDay - 1;
        let find = false;
        daysList.forEach((item) => {
            if (item.day === day) {
                find = true;
            }
        });

        if (find) {
            this.setState({
                selectedDay: day
            });
        } else {
            this.setState({
                selectedDay: daysList[daysList.length - 1].day
            });
        }
    }

    render() {
        let printEvents = [];
        const day = this.state.selectedDay < 10 ? `0${this.state.selectedDay}` : this.state.selectedDay;

        if (this.state.events.length > 0 && !this.state.isLoading) {
            const printDate = `2018-02-${day}`;
            printEvents = this.state.events.filter(item => item.date === printDate);
        }
        const FullDay = daysList.filter(item => item.day === this.state.selectedDay);

        return (
            <section className="calendar">
                <Dates month_name={'Февраль 2018'} days_list={daysList} selectedDate={this.state.selectedDay} onDateSelect={this.updateSelectedDate} />
                {this.state.isLoading ?
                    <Preloader /> : <EventsList
                        items={printEvents}
                        full={FullDay[0]}
                        limits={this.props.limits}
                        nextSlide={this.nextSlide}
                        prevSlide={this.prevSlide}
                    />}
            </section>
        );
    }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar/index.jsx